// Platform admin work list. English counterpart of werklijstApp.nl.ts (the items themselves stay
// in Dutch: they come from docs/werklijst.json).
export const appWerklijstEn = {
    title: 'Work list',
    subtitle: 'Only for you as admin · updated {when}',
    progress: '{done} of {total} done',
    progressLabel: 'Progress: {done} of {total} items done',
    progressRegion: 'Progress',
    status: {
        waiting_on_you: 'Waiting on you',
        in_progress: 'In progress',
        planned: 'Planned',
        later: 'Later',
        done: 'Done',
    },
    filterAll: 'All',
    filterLabel: 'Show',
    filterActive: 'You’re only seeing: {status}',
    showAll: 'Show all',
    needsYou: 'What I need from you',
    needsYouCount: {
        one: 'One item is waiting on you.',
        other: '{count} items are waiting on you.',
    },
    show: 'View',
    doneAt: 'Done on {when}',
    whatIsIt: 'What is it?',
    yourAction: 'What do you need to do?',
    numberLabel: 'item {n} from your feedback',
    groupCount: '{done} of {total} done',
    emptyTitle: 'Nothing with this status',
    emptyBody: 'Pick another status above, or All.',
    unavailable: 'The work list can’t be read right now. Please try again later.',
};
//# sourceMappingURL=werklijstApp.en.js.map